function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { Constants } from '@shared/utils/constants';
import { get, post, patch, del, AuthenticationTypes } from '@shared/services/http/httpProtocol';
import { mapEnrichReviewCommentToIAppReviewComment } from '@shared/utils/reviewsUtils';
const commonHttpOptions = {
    requireCorrelationId: true,
    stringifyPostData: false,
    authenticationType: AuthenticationTypes.Spza,
    setBearerHeader: true
};
export const ReviewCommentsQueryStrings = {
    OfferId: 'offerId',
    ApiVersion: 'api-version',
    PageNumber: 'PageNum',
    PageSize: 'PageSize',
    Sorting: 'Sorting'
};
/**
 * Creates a review comment
 * @param Object containing named parameters for the call
 * @returns Promise with the response, both for success and failure. in case of success, will contain the created comment
 */ export function createReviewComment(_0) {
    return _async_to_generator(function*({ commentContent, offerId, reviewId, reviewsAPI, reviewsAPIVersion, source }) {
        try {
            const reviewComment = yield post(`${reviewsAPI}/${reviewId}/comments/`, commonHttpOptions).addQueryEntry(ReviewCommentsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(ReviewCommentsQueryStrings.OfferId, offerId).setData({
                content: commentContent.trim(),
                source
            }).request();
            return {
                reviewComment: mapEnrichReviewCommentToIAppReviewComment(reviewComment)
            };
        } catch (error) {
            var _error_response;
            return {
                error: ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.text) || error
            };
        }
    }).apply(this, arguments);
}
/**
 * Get a review's comment list
 * @param Object containing named parameters for the call
 * @returns Promise with the response, containing a list of comments for the given review
 */ export function getAppReviewComments(_0) {
    return _async_to_generator(function*({ offerId, reviewId, page, itemsPerPage = Constants.Reviews.CommentsPerPage, reviewsAPI, reviewsAPIVersion }) {
        try {
            const { comments, pagination_info: paginationInfo, total_comments: totalComments } = yield get(`${reviewsAPI}/${reviewId}/comments/`, commonHttpOptions).addQueryEntry(ReviewCommentsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(ReviewCommentsQueryStrings.OfferId, offerId).addQueryEntry(ReviewCommentsQueryStrings.PageNumber, page.toString()).addQueryEntry(ReviewCommentsQueryStrings.PageSize, itemsPerPage.toString()).addQueryEntry(ReviewCommentsQueryStrings.Sorting, 'asc').request();
            return {
                comments: comments.map((c)=>mapEnrichReviewCommentToIAppReviewComment(c)),
                paginationInfo: {
                    pageNumber: paginationInfo.page_number,
                    pageSize: paginationInfo.page_size
                },
                totalComments
            };
        } catch (error) {
            return {
                error,
                comments: [],
                totalComments: 0,
                paginationInfo: {
                    pageNumber: 0,
                    pageSize: 0
                }
            };
        }
    }).apply(this, arguments);
}
/**
 * Updates a review comment's content
 * @param Object containing named parameters for the call
 * @returns Promise with the response, both for success and failure. in case of success, will contain the modified comment
 */ export function updateReviewComment(_0) {
    return _async_to_generator(function*({ commentId, commentContent, offerId, reviewId, reviewsAPI, reviewsAPIVersion }) {
        try {
            const reviewComment = yield patch(`${reviewsAPI}/${reviewId}/comments/${commentId}`, commonHttpOptions).addQueryEntry(ReviewCommentsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(ReviewCommentsQueryStrings.OfferId, offerId).setData({
                content: commentContent.trim()
            }).request();
            return {
                reviewComment: mapEnrichReviewCommentToIAppReviewComment(reviewComment)
            };
        } catch (error) {
            return {
                error
            };
        }
    }).apply(this, arguments);
}
/**
 * Deletes a review comment (this is a soft deletion, meaning that the comment will still be in the database and will show in the list as deleted)
 * @param Object containing named parameters for the call
 * @returns Promise with the response, both for success and failure. in case of success, will contain the comment after the deletion
 */ export function deleteReviewComment(_0) {
    return _async_to_generator(function*({ commentId, offerId, reviewId, reviewsAPI, reviewsAPIVersion }) {
        try {
            const reviewComment = yield del(`${reviewsAPI}/${reviewId}/comments/${commentId}`, commonHttpOptions).addQueryEntry(ReviewCommentsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(ReviewCommentsQueryStrings.OfferId, offerId).request();
            return {
                reviewComment: mapEnrichReviewCommentToIAppReviewComment(reviewComment)
            };
        } catch (error) {
            return {
                error
            };
        }
    }).apply(this, arguments);
}
